import { __rest } from "tslib";
import * as React from 'react';
export var ListItem = function ListItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["children"]);

  return React.createElement("li", Object.assign({}, props), children);
};